module.exports = __webpack_public_path__ + "img/port3.c64d5f2a.png";